import { differenceInMonths, format, isValid } from "date-fns";

type DateLike = Date | string | undefined | null;

const parseValidDate = (value: DateLike): Date | null => {
  if (value == null || value === "") return null;
  const d = new Date(value);
  return isValid(d) ? d : null;
};

export const safeFormatDate = (value: DateLike, dateFormat: string): string => {
  const d = parseValidDate(value);
  return d ? format(d, dateFormat) : "";
};

export const safeCvLangDateCell = (value: DateLike, cvLang: string): string => {
  const d = parseValidDate(value);
  if (!d) return "";
  return cvLang === "en"
    ? format(d, "dd-MMM-yyyy")
    : d.toLocaleDateString("ar-SA", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      });
};

export const safeAgeYearsCell = (value: DateLike, cvLang: string): string => {
  const d = parseValidDate(value);
  if (!d) return "";
  return Math.floor(differenceInMonths(new Date(), d) / 12).toLocaleString(
    cvLang === "ar" ? "ar-SA" : "en-US"
  );
};
